import React, { useState, useEffect } from 'react';
import './contact-us.css';
import Beard from '../../assets/images/logo-beard2.svg';
import Footer from '../../layout/footer/footer';
import { Col, Form } from 'react-bootstrap';
import ContactUsIcon from '../../assets/images/contact-us.png';
import { LoadCanvasTemplate, loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha';
import Refresh from '../../assets/icons/refresh.svg';

function ContactUs() {
    const [captchaInput, setCaptchaInput] = useState('');
    const [captchaError, setCaptchaError] = useState(false);

    // Load captcha on component mount
    useEffect(() => {
        loadCaptchaEnginge(6,'white','black','numbers');
    }, []);

    const handleCaptchaValidation = () => {
        if (validateCaptcha(captchaInput)) {
            setCaptchaError(false);
            alert('کد امنیتی تأیید شد.');
        } else {
            setCaptchaError(true);
            alert('کد امنیتی اشتباه است.');
        }
    };

    return (
        <>
            <div className='container ' style={{marginBottom: '4em'}}>
                <div className='d-flex align-items-center title gap-3'>
                    <img src={Beard} alt="" />
                    ارتباط با ما
                </div>

                        <h4 className='font-bold text-[#001966] title2 mobile'>اگر نیاز به راهنمایی دارید، با ما در تماس باشید.</h4>
                <div className="flex  align-items-center max-md:gap-4 flex-revers">
                    <Col sm='12' md="6" className='text-end'>
                    <h4 className='font-bold text-[#001966]  web'>اگر نیاز به راهنمایی دارید، با ما در تماس باشید.</h4>

                        <Form className='mt-5'>
                            <div className="text-sm font-bold">
                                <div className="flex gap-2 align-items-end flex-col-dir">
                                    <Form.Group className="mb-3 w-1/2 max-md:!w-full">
                                        <Form.Label className='!font-bold'>نام و نام خانوادگی <span className="text-[red]"> * </span></Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                    <Form.Group className="mb-3 w-1/2 max-md:!w-full">
                                        <Form.Label className='!font-bold'>شماره تماس <span className="text-[red]"> * </span></Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </div>
                                <div className="flex gap-2 align-items-end flex-col-dir">
                                    <Form.Group controlId="text" className="mb-3 w-1/2 max-md:!w-full">
                                        <Form.Label className='!font-bold'>ایمیل</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                    <Form.Group className="mb-3 w-1/2 max-md:!w-full">
                                        <Form.Label className='!font-bold'>کد امنیتی</Form.Label>
                                        <div className="d-flex align-items-center">
                                            <Form.Control
                                                value={captchaInput}
                                                onChange={(e) => setCaptchaInput(e.target.value)}
                                                className='flex-1'
                                            />
                                            <div className="captcha-container h-[48px] d-flex align-items-center gap-2 ms-2">
                                                <LoadCanvasTemplate />
                                                <button
                                                    type="button"
                                                    onClick={() =>loadCaptchaEnginge(6,'white','black','numbers')}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        fontSize: '18px',
                                                        color: '#007BFF',
                                                        marginLeft: '10px',
                                                        width: '18px'
                                                    }}
                                                    title="تولید مجدد کد امنیتی"
                                                >
                                                    <img src={Refresh} alt="" />
                                                </button>
                                            </div>
                                        </div>
                                        {captchaError && (
                                            <div className="text-danger mt-2">کد امنیتی اشتباه است.</div>
                                        )}
                                    </Form.Group>
                                </div>
                            </div>
                            <button
                                className='btn btn-primary max-md:!w-full'
                                type='button'
                                onClick={handleCaptchaValidation}
                            >
                                ثبت درخواست
                            </button>
                        </Form>
                    </Col>
                    <Col sm='12' md="6">
                        <img src={ContactUsIcon} alt="" />
                    </Col>
                </div>
            </div>
            <div className="home-footer mt-40">
                <Footer />
            </div>
        </>
    );
}

export default ContactUs;
